import './assets/styles/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { Quasar, Cookies, Notify } from 'quasar'
import iconSet from 'quasar/icon-set/mdi-v7'
import '@quasar/extras/mdi-v7/mdi-v7.css'

// Import icon libraries

import '@quasar/extras/roboto-font/roboto-font.css'
// import '@quasar/extras/material-icons/material-icons.css'

// A few examples for animations from Animate.css:
// import @quasar/extras/animate/fadeIn.css
// import @quasar/extras/animate/fadeOut.css

// Import Quasar css
import 'quasar/src/css/index.sass'
import * as Sentry from '@sentry/vue'
import { createSentryPiniaPlugin } from '@sentry/vue'

import App from './App.vue'
import router from './router'
import { trackAffiliateVisit } from './utils/affiliate'

const app = createApp(App)

Sentry.init({
  app,
  dsn: 'https://3d78c531c044a228af389f0103589aff@o4508145243324416.ingest.us.sentry.io/4508362849583104',
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  environment: import.meta.env.MODE,
  // // Tracing
  // tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

const pinia = createPinia()
pinia.use(createSentryPiniaPlugin())

app.use(pinia)
app.use(router)
app.use(Quasar, {
  iconSet,
  config: {
    dark: true,
    notify: {
      position: 'top-right',
      timeout: 2500,
      textColor: 'white'
    }
  },
  plugins: {
    Cookies,
    Notify
  } // import Quasar plugins and add here
})

app.config.errorHandler = (err, vm, info) => {
  console.error('Error:', err)
  console.error('Vue component:', vm)
  console.error('Additional info:', info)
  Sentry.captureException(err)
}

app.mount('#app')

// Track affiliate visit if code is present in URL
trackAffiliateVisit().catch((err) => {
  console.error('Failed to track affiliate visit:', err)
  Sentry.captureException(err)
})
